@if (isStoreSelected()) {
  <div class="row mb-2">
    <div class="col float-start">
      <h2>{{ store.name }}</h2>
    </div>
    <div class="store-nav col float-end text-end">
      @if (showPage(Authority.AUTH_SEE_PREDICTIONS, Authority.AUTH_SEE_ROTAS)) {
        <a
          routerLink="/stores/{{store.slug}}"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{exact: true}"
        class="btn btn-link">Schedule</a>
      }
      @if (showPage(
        Authority.AUTH_SEE_TRADING_TIMES,
        Authority.AUTH_SEE_STORE_REQUIREMENTS,
        Authority.AUTH_SEE_STORE_BANKING,
        Authority.AUTH_SEE_STORE_CLOSED)) {
        <a
          routerLink="/store-details/{{store.slug}}"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{exact: true}"
        class="btn btn-link">Store</a>
      }
      @if (showPage(Authority.AUTH_SEE_EMPLOYEES)) {
        <a
          routerLink="/employees/{{store.slug}}"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{exact: true}"
        class="btn btn-link">Employees</a>
      }
    </div>
  </div>
}
